<template>
  <div class="mb-5 md:mb-15 2xl:mb-20">
    <div class="border border-gray-600 border-dashed rounded xxl:mx-20 2xl:mx-40">
      <p class="text-base text-center my-8 uppercase">
        Modèle de page
      </p>


      <p
        class="text-base text-center my-8 uppercase text-pink-600"
        v-if="evaluationInProgress"
      >
        Modification impossible : évaluation en cours sur ce modèle de page.
      </p>

      <div class="mb-8 flex flex-col md:flex-row justify-center items-center space-y-1.5 md:space-x-5">
        <action-button
          id="tour_visualiser"
          v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_APERCU)"
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-orange-300"
          bg-color-square="bg-orange-100"
          icon-color="text-orange-600"
          libelle="Visualiser"
          icon="eye"
          @clickAction="showPreview()"
        />
                
        <action-button
          v-if="$can(constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_MODELE_DE_PAGE)"
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-teal-300"
          bg-color-square="bg-teal-100"
          icon-color="text-teal-600"
          libelle="Attribuer"
          icon="people"
          @clickAction="assignTemplate()"
        />
        <action-button
          v-if="isActive == 1 && !evaluationInProgress && $can(constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER)"
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-indigo-300"
          bg-color-square="bg-indigo-100"
          icon-color="text-indigo-600"
          libelle="Désactiver"
          icon="power"
          @clickAction="deactivateTemplate"
        />
        <action-button
          v-else-if="isActive == 0 && !evaluationInProgress && $can(constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER)"
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-pink-300"
          bg-color-square="bg-pink-100"
          icon-color="text-pink-600"
          libelle="Activer"
          icon="power"
          @clickAction="activateTemplate"
        />
        <action-button
          v-if="!evaluationInProgress && $can(constants.PERMISSION_MODELE_DE_PAGE_SUPPRIMER) && canDelete"
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-gray-300"
          bg-color-square="bg-gray-100"
          icon-color="text-gray-600"
          libelle="Supprimer"
          icon="trash-2"
          @clickAction="confirmDeleteTemplate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from '../ActionButton.vue';
import Constants from './../../constants';

export default {
  props:{
    evaluationInProgress: Boolean,
    isActive: [Number, String],
    canDelete: Boolean,
  },

  emits: ['preview', 'activateTemplate', 'deactivateTemplate', 'confirmDelete', 'assignTemplate'],

  components:{
    ActionButton,
  },

  data() {
    return {
      constants: Constants
    };
  },

  methods:{
    showPreview(){
      if(this.$can(Constants.PERMISSION_MODELE_DE_PAGE_APERCU)){
        this.$emit('preview');
      }
    },

    activateTemplate(){
      if(!this.evaluationInProgress && this.$can(Constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER)){
        this.$emit('activateTemplate');
      }
    },

    deactivateTemplate(){
      if(!this.evaluationInProgress && this.$can(Constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER)){
        this.$emit('deactivateTemplate');
      }
    },

    confirmDeleteTemplate(){
      if(!this.evaluationInProgress && this.$can(Constants.PERMISSION_MODELE_DE_PAGE_SUPPRIMER) && this.canDelete){
        this.$emit('confirmDelete');
      }
    },

    assignTemplate() {
      if(this.$can(Constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_MODELE_DE_PAGE)){
        this.$emit('assignTemplate');
      }
    }
  }

};
</script>
